import { MasterButton } from "App/Component/ui";
import {
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers";
import { useState } from "react";
import { postLokasi, updateLokasi } from "./helpers";
import LokasiForm from "./LokasiForm";

const { makeStyles } = require("@material-ui/core");
const { default: Title } = require("App/Component/ui/title/Title");
const { DrawerMaster } = require("components/molecules");

function LokasiPreview({
  open,
  setOpen,
  toggleDrawer,
  formDataInfo,
  setFormDataInfo,
  formDataJadwal,
  setFormDataJadwal,
  formDataAlamat,
  setFormDataAlamat,
  formDataKontak,
  setFormDataKontak,
  latitude,
  setLatitude,
  longitude,
  setLongitude,
  setNewData,
}) {
  const useStyles = makeStyles({
    paper: {
      width: "80%",
    },
  });

  const styles = useStyles();

  const BUTTON_SUBMIT = {
    label: "SIMPAN",
    color: "lightgreen",
    state: false,
    disabled: false,
  };

  const [disabled, setDisabled] = useState(BUTTON_SUBMIT);

  navigator.geolocation.getCurrentPosition((e) => {
    setLatitude(e.coords.latitude);
    setLongitude(e.coords.longitude);
  });

  // const handleClickSubmit2 = async () => {
  //   console.log("Hasil Alamat : ", formDataInfo.poliklinikValue);

  //   if (isNull(formDataInfo.poliklinikValue)) {
  //     defaultToastError("Poliklinik Belum Di Isi");
  //     return false;
  //   }
  // };

  const handleClickSubmit = async () => {
    //for Info Lokasi
    if (isNull(formDataInfo.kode)) {
      defaultToastError("Kode Ruangan Belum Di Isi");
      return false;
    } else if (isNull(formDataInfo.name)) {
      defaultToastError("Nama Ruangan Belum Di Isi");
      return false;
    } else if (isNull(formDataInfo.description)) {
      defaultToastError("Deskripsi Ruangan Belum Di Isi");
      return false;
    } else if (isNull(formDataInfo.type)) {
      defaultToastError("Tipe Fungsi Lokasi Belum Di Isi");
      return false;
    } else if (isNull(formDataInfo.status)) {
      defaultToastError("Status Lokasi Belum Di Isi");
      return false;
    } else if (isNull(formDataInfo.mode)) {
      defaultToastError("Mode Lokasi Belum Di Isi");
      return false;
    } else if (isNull(formDataInfo.jenisLokasiValue)) {
      defaultToastError("Jenis Lokasi Belum Di Isi");
      return false;
    }

    if(formDataInfo.jenisLokasiValue === 'poli'){
      if (isNull(formDataInfo.poliklinikValue)) {
        defaultToastError("Poliklinik Belum Di Isi");
        return false;
      }
    }else{
      if (isNull(formDataInfo.layananValue)) {
        defaultToastError("Layanan Belum Di Isi");
        return false;
      }
    }

    //for Jadwal Lokasi
    if (formDataJadwal.available === true) {
      if (isNull(formDataJadwal.hari_awal)) {
        defaultToastError("Buka Hari Belum Di Pilih");
        return false;
      } else if (isNull(formDataJadwal.hari_akhir)) {
        defaultToastError("Sampai Hari Belum Di Pilih");
        return false;
      } else if (isNull(formDataJadwal.jam_awal)) {
        defaultToastError("Jam Buka Belum Di Pilih");
        return false;
      } else if (isNull(formDataJadwal.jam_akhir)) {
        defaultToastError("Jam Tutup Belum Di Pilih");
        return false;
      } else if (isNull(formDataJadwal.availabilityExecptions)) {
        defaultToastError("Hari Lainnya Belum Di Isi");
        return false;
      }
    }

    //for Alamat Lokasi
    if (formDataAlamat.available === true) {
      if (isNull(formDataAlamat.type)) {
        defaultToastError("Kategori Alamat Lokasi Belum Di Isi");
        return false;
      } else if (isNull(formDataAlamat.province)) {
        defaultToastError("Provinsi Belum Di Isi");
        return false;
      } else if (isNull(formDataAlamat.city)) {
        defaultToastError("Kota Belum Di Isi");
        return false;
      } else if (isNull(formDataAlamat.district)) {
        defaultToastError("Kecamatan Belum Di Isi");
        return false;
      } else if (isNull(formDataAlamat.sub_district)) {
        defaultToastError("Kelurahan Belum Di Isi");
        return false;
      } else if (isNull(formDataAlamat.line)) {
        defaultToastError("Alamat Lengkap Belum Di Isi");
        return false;
      } else if (isNull(formDataAlamat.postalCode)) {
        defaultToastError("Kode POS Belum Di Isi");
        return false;
      }
    }

    const operationalStatus = isNull(formDataInfo.operationalStatus)
      ? ""
      : formDataInfo.operationalStatus;

    const telecom =
      isNull(formDataKontak.phone) &&
      isNull(formDataKontak.email) &&
      isNull(formDataKontak.url)
        ? []
        : [
            {
              system: "phone",
              value: isNull(formDataKontak.phone) ? null : formDataKontak.phone,
              use: "work",
            },
            {
              system: "email",
              value: isNull(formDataKontak.email) ? null : formDataKontak.email,
              use: "work",
            },
            {
              system: "url",
              value: isNull(formDataKontak.url) ? null : formDataKontak.url,
              use: "work",
            },
          ];

    const physicalType = {
      coding: isNull(formDataInfo.physicalTypeValue)
        ? []
        : [
            {
              system:
                "http://terminology.hl7.org/CodeSystem/location-physical-type",
              code: formDataInfo.physicalTypeValue,
              display: formDataInfo.physicalTypeLabel,
            },
          ],
    };

    const hoursOfOperation =
      formDataJadwal.available === false
        ? []
        : [
            {
              hari_awal: formDataJadwal.hari_awal,
              hari_akhir: formDataJadwal.hari_akhir,
              jam_awal: formDataJadwal.jam_awal,
              jam_akhir: formDataJadwal.jam_akhir,
            },
          ];

    const availabilityExecptions =
      formDataJadwal.available === false
        ? ""
        : formDataJadwal.availabilityExecptions;

    const position =
      isNull(longitude) && isNull(latitude)
        ? {
            longitude: 0,
            latitude: 0,
            altitude: 0,
          }
        : {
            longitude: longitude,
            latitude: latitude,
            altitude: 0,
          };

    const address =
      formDataAlamat.available === false
        ? {}
        : {
            use: "work",
            type: formDataAlamat.type,
            line: [formDataAlamat.line],
            city: formDataAlamat.city_name,
            postalCode: formDataAlamat.postalCode,
            country: "ID",
            extension: [
              {
                url: "https://fhir.kemkes.go.id/r4/StructureDefinition/administrativeCode",
                extension: [
                  {
                    url: formDataAlamat.province_name,
                    valueCode: formDataAlamat.province.toString(),
                  },
                  {
                    url: formDataAlamat.city_name,
                    valueCode: formDataAlamat.city,
                  },
                  {
                    url: formDataAlamat.district_name,
                    valueCode: formDataAlamat.district,
                  },
                  {
                    url: formDataAlamat.sub_district_name,
                    valueCode: formDataAlamat.sub_district,
                  },
                ],
              },
            ],
          };

    if (formDataInfo.isUpdate === false) {
      const response = await postLokasi(
        isNull(formDataInfo.id_location) ? null : formDataInfo.id_location,
        formDataInfo.kode,
        formDataInfo.poliklinikValue,
        formDataInfo.layananValue,
        formDataInfo.jenisLokasiValue,
        formDataInfo.name,
        formDataInfo.description,
        formDataInfo.status,
        formDataInfo.mode,
        formDataInfo.type,
        operationalStatus,
        telecom,
        physicalType,
        formDataInfo.id,
        "",
        hoursOfOperation,
        availabilityExecptions,
        position,
        address,
        {}
      );
      if (response.state) {
        defaultToastSuccess(response.message);
        setOpen(false);
        setNewData(1, 10, {
          parent_id_location: formDataInfo.id_location,
          name: "",
        });
      } else {
        defaultToastError(response.message);
      }
    } else {
      //   const response = await updateLokasi(
      //     formDataInfo.id_location,
      //     formDataInfo.parent_id_location,
      //     formDataInfo.kode,
      //     formDataInfo.poliklinikValue,
      //     formDataInfo.name,
      //     formDataInfo.description,
      //     formDataInfo.status,
      //     formDataInfo.mode,
      //     formDataInfo.type,
      //     isNull(formDataInfo.operationalStatus)
      //       ? ""
      //       : formDataInfo.operationalStatus,
      //     isNull(formDataKontak.phone) &&
      //       isNull(formDataKontak.email) &&
      //       isNull(formDataKontak.url)
      //       ? []
      //       : [
      //           {
      //             system: "phone",
      //             value: isNull(formDataKontak.phone)
      //               ? null
      //               : formDataKontak.phone,
      //             use: "work",
      //           },
      //           {
      //             system: "email",
      //             value: isNull(formDataKontak.email)
      //               ? null
      //               : formDataKontak.email,
      //             use: "work",
      //           },
      //           {
      //             system: "url",
      //             value: isNull(formDataKontak.url) ? null : formDataKontak.url,
      //             use: "work",
      //           },
      //         ],
      //     {
      //       coding: isNull(formDataInfo.physicalTypeValue)
      //         ? []
      //         : [
      //             {
      //               system:
      //                 "http://terminology.hl7.org/CodeSystem/location-physical-type",
      //               code: formDataInfo.physicalTypeValue,
      //               display: formDataInfo.physicalTypeLabel,
      //             },
      //           ],
      //     },
      //     "",
      //     formDataInfo.id,
      //     formDataJadwal.available === false
      //       ? []
      //       : [
      //           {
      //             hari_awal: formDataJadwal.hari_awal,
      //             hari_akhir: formDataJadwal.hari_akhir,
      //             jam_awal: formDataJadwal.jam_awal,
      //             jam_akhir: formDataJadwal.jam_akhir,
      //           },
      //         ],
      //     formDataJadwal.available === false
      //       ? ""
      //       : formDataJadwal.availabilityExecptions,
      //     isNull(longitude) && isNull(latitude)
      //       ? {
      //           longitude: 0,
      //           latitude: 0,
      //           altitude: 0,
      //         }
      //       : {
      //           longitude: longitude,
      //           latitude: latitude,
      //           altitude: 0,
      //         },
      //     formDataAlamat.available === false
      //       ? {}
      //       : {
      //           use: "work",
      //           type: formDataAlamat.type,
      //           line: [formDataAlamat.line],
      //           city: formDataAlamat.city_name,
      //           postalCode: formDataAlamat.postalCode,
      //           country: "ID",
      //           extension: [
      //             {
      //               url: "https://fhir.kemkes.go.id/r4/StructureDefinition/administrativeCode",
      //               extension: [
      //                 {
      //                   url: formDataAlamat.province_name,
      //                   valueCode: formDataAlamat.province.toString(),
      //                 },
      //                 {
      //                   url: formDataAlamat.city_name,
      //                   valueCode: formDataAlamat.city,
      //                 },
      //                 {
      //                   url: formDataAlamat.district_name,
      //                   valueCode: formDataAlamat.district,
      //                 },
      //                 {
      //                   url: formDataAlamat.sub_district_name,
      //                   valueCode: formDataAlamat.sub_district,
      //                 },
      //               ],
      //             },
      //           ],
      //         },
      //     {}
      //   );

      const response = await updateLokasi({
        id_location: formDataInfo.id_location,
        parent_id_location: formDataInfo.parent_id_location,
        kode: formDataInfo.kode,
        id_poliklinik: formDataInfo.poliklinikValue,
        id_layanan: formDataInfo.layananValue,
        jenis_lokasi: formDataInfo.jenisLokasiValue,
        name: formDataInfo.name,
        description: formDataInfo.description,
        status: formDataInfo.status,
        mode: formDataInfo.mode,
        type: formDataInfo.type,
        operationalStatus: operationalStatus,
        telecom: telecom,
        physicalType: physicalType,
        id: formDataInfo.id,
        partOf_parent_id: "",
        hoursOfOperation: hoursOfOperation,
        availabilityExecptions: availabilityExecptions,
        position: position,
        address: address,
        identifier: {},
      });
      if (response.state) {
        defaultToastSuccess(response.message);
        setOpen(false);
        if (isNull(formDataInfo.parent_id_location)) {
          setNewData();
        } else {
          setNewData(1, 10, {
            parent_id_location: formDataInfo.parent_id_location,
            name: "",
          });
        }
      } else {
        defaultToastError(response.message);
      }
    }
  };

  return (
    <DrawerMaster
      open={open}
      toggleDrawer={toggleDrawer}
      widthList={"100%"}
      styles={{ paper: styles.paper }}>
      <Title title='Form Satu Sehat - Lokasi' />
      <LokasiForm
        formDataInfo={formDataInfo}
        setFormDataInfo={setFormDataInfo}
        formDataJadwal={formDataJadwal}
        setFormDataJadwal={setFormDataJadwal}
        formDataAlamat={formDataAlamat}
        setFormDataAlamat={setFormDataAlamat}
        formDataKontak={formDataKontak}
        setFormDataKontak={setFormDataKontak}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "10px",
        }}>
        <MasterButton
          className={"mt-1 mb-1"}
          type='button'
          color={"danger"}
          name={"Batalkan"}
          size='md'
          onClick={() => setOpen(false)}></MasterButton>
        <MasterButton
          className={"mt-1 mb-1"}
          type='button'
          color={disabled.color}
          name={disabled.label}
          size='md'
          onClick={() => handleClickSubmit()}></MasterButton>
      </div>
    </DrawerMaster>
  );
}

export default LokasiPreview;
